import { RootState } from 'store';
import Reducers from 'types/Reducers';

export const selectQuizGroupData = (state: RootState) => state[Reducers.QuizGroup].data;
export const selectQuizGroupLoading = (state: RootState) => state[Reducers.QuizGroup].loading;
